export default {"src":"/_next/static/media/avatar_rays.ddfe81a0.svg","height":116,"width":133,"blurWidth":0,"blurHeight":0};